import * as AriaUtils from 'owa-shared-start/lib/ariaUtils';
import BootError from 'owa-shared-start/lib/interfaces/BootError';
import calculateBootResult from 'owa-shared-start/lib/calculateBootResult';
import { getRedirectInProgress } from './isBootError';
import { createBootReliabilityAriaEvent } from 'owa-shared-start/lib/createBootReliabilityAriaEvent';
import { getRetryStrategyFromError } from 'owa-shared-start/lib/getRetryStrategyFromError';
import { getServerErrorDiagnostics } from 'owa-shared-start/lib/getServerErrorDiagnostics';
import { TEN_SECONDS_IN_MS } from 'owa-shared-start/lib/timeConstants';
import { handleBootErrorForMini } from './handleBootErrorForMini';

export function onBootError(error: BootError): Promise<any> {
    // Do not do the custom redirection if already there is a redirection in progress
    if (getRedirectInProgress()) {
        return Promise.resolve(null);
    }

    const errorDiagnostics = getServerErrorDiagnostics(error);
    let bootResult = calculateBootResult(
        errorDiagnostics.err,
        errorDiagnostics.st,
        error,
        errorDiagnostics.esrc
    );

    const retryStrategy = getRetryStrategyFromError(bootResult, errorDiagnostics.esrc);
    if (retryStrategy) {
        bootResult = 'retry';
    }

    // if we are not retrying, let's do the default time out. If not, let's extend the time out to 10 seconds
    return AriaUtils.postSignal(
        createBootReliabilityAriaEvent(bootResult, errorDiagnostics, undefined, error),
        retryStrategy ? undefined : TEN_SECONDS_IN_MS
    ).then(async () => {
        handleBootErrorForMini(bootResult, error, retryStrategy, errorDiagnostics, null);
    });
}
